import { Toaster } from "react-hot-toast";

/**
 * App-wide toast notifications styled to match web_admin's react-toastify look:
 * a clean light card, bottom-left placement, a colored status icon and a colored
 * progress bar that drains over the toast's lifetime.
 *
 * Mount this once near the app root. Every existing `toast.success(...)` /
 * `toast.error(...)` call picks up this styling automatically, no call-site
 * changes needed. Do NOT also mount a bare <Toaster /> elsewhere, or each
 * message renders twice.
 */
const TOAST_DURATION = 3000;

export default function AppToaster() {
  return (
    <Toaster
      position="bottom-left"
      gutter={10}
      toastOptions={{
        duration: TOAST_DURATION,
        className: "jw-toast",
        style: {
          background: "#ffffff",
          color: "#1f2937",
          border: "1px solid #e5e7eb",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          padding: "12px 16px",
          fontSize: "14px",
          fontWeight: 500,
          // Never wider than the screen minus the toaster's 16px insets.
          maxWidth: "min(400px, calc(100vw - 32px))",
        },
        success: {
          className: "jw-toast jw-toast--success",
          iconTheme: { primary: "#16a34a", secondary: "#ffffff" },
        },
        error: {
          className: "jw-toast jw-toast--error",
          iconTheme: { primary: "#dc2626", secondary: "#ffffff" },
        },
      }}
    />
  );
}
